import styled from 'styled-components'

export const Wrapper = styled.div<{ isMobile?: boolean }>`
  height: ${({ isMobile }) => (isMobile ? '80px' : '20px')};

  margin-bottom: 20px;
`
